class VpAccordion extends HTMLElement {
  constructor() {
    super();
    this.head = this.querySelector('vp-accordion-head');
    this.body = this.querySelector('vp-accordion-body');
  }

  connectedCallback() {
    if (!this.head || !this.body) {
      return;
    }

    this.head.style.cursor = 'pointer';
    this.head.addEventListener('click', () => this.toggle());

    this.toggle(this.hasAttribute('open'));
  }

  toggle(force) {
    const open = typeof force === 'boolean' ? force : !this.hasAttribute('open');
    if (open) {
      this.setAttribute('open', '');
      this.body.style.display = 'grid';
    } else {
      this.removeAttribute('open');
      this.body.style.display = 'none';
    }
  }
}

if (!customElements.get('vp-accordion')) {
  customElements.define('vp-accordion', VpAccordion);
}